import { render, staticRenderFns } from "./videoWechatPay.vue?vue&type=template&id=239d95bd&scoped=true&"
import script from "./videoWechatPay.ts?vue&type=script&lang=js&"
export * from "./videoWechatPay.ts?vue&type=script&lang=js&"
import style0 from "./videoWechatPay.less?vue&type=style&index=0&id=239d95bd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "239d95bd",
  null
  
)

export default component.exports